import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import { COLLAPSED_SIDEBAR_WIDTH, SIDEBAR_WIDTH, hoverTime } from 'config/appConfig';
import { setSidebarHover } from 'reducers/ThemeOptions';
import SidebarMainContent from 'layout-components/SidebarMainContent';

const MdUpSidebar = () => {
  const dispatch = useDispatch();
  const sidebarToggle = useSelector(state => state.ThemeOptions.sidebarToggle);
  const sidebarHover = useSelector(state => state.ThemeOptions.sidebarHover);

  const toggleTimer = useRef(null);
  const sideBarElement = useRef(null);

  const toggleHoverOn = event => {
    if (!sidebarToggle || sidebarHover) {
      return;
    }
    let { currentTarget } = event;
    currentTarget.style.cursor = 'wait';
    sideBarElement.current = currentTarget;
    toggleTimer.current = setTimeout(() => {
      dispatch(setSidebarHover(true));
      currentTarget.style.cursor = 'default';
    }, hoverTime);
  };

  const toggleHoverOff = () => {
    if (sideBarElement.current) {
      sideBarElement.current.style.cursor = 'default';
      sideBarElement.current = null;
    }
    clearTimeout(toggleTimer.current);
    dispatch(setSidebarHover(false));
    toggleTimer.current = null;
  };

  return (
    <>
      <Paper
        onMouseEnter={toggleHoverOn}
        onMouseLeave={toggleHoverOff}
        style={{
          overflow: 'hidden',
          zIndex: 60,
          position: 'fixed',
          width: sidebarHover || !sidebarToggle ? SIDEBAR_WIDTH : COLLAPSED_SIDEBAR_WIDTH,
          transition: 'all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1)',
        }}
        square
        elevation={3}>
        <SidebarMainContent />
      </Paper>
    </>
  );
};

export default MdUpSidebar;
